import { StyleSheet } from 'react-native';

const mutedText = {
  fontSize: 17,
  lineHeight: 26,
  color: 'inherit',
} as const;

export const eventDetailsSummaryStyles = StyleSheet.create({
  wrapper: {
    alignSelf: 'stretch',
  },
  mutedText,
  attendanceSection: {
    marginTop: 26,
  },
  scheduleSection: {
    alignSelf: 'stretch',
  },
  scheduleList: {
    alignSelf: 'stretch',
  },
  scheduleDay: {
    marginBottom: 8,
  },
  scheduleDayLabel: {
    fontWeight: '700',
  },
});
